import { AiFillDashboard } from "react-icons/ai";
import { FaChartPie, FaHammer, FaFileInvoiceDollar } from "react-icons/fa";
import { GiSupersonicArrow } from "react-icons/gi";
import {
  MdDashboard,
  MdOutlineCategory,
  MdLocationOn,
  MdWorkspacesOutline,
  MdSettings,
} from "react-icons/md";

export const SidebarNav = [
  {
    type: "main",
    title: "Dashboard",
    icon: (
      <AiFillDashboard
        className={`w-6 h-6 group-hover:text-primary    transition-all duration-500 ease-out`}
      />
    ),
    path: "/",
  },
  {
    type: "separator",
    title: "Cases",
  },
  {
    type: "button",
    title: "Log",
    icon: (
      <MdDashboard
        className={`w-6 h-6 shrink-0 group-hover:text-primary  transition-all duration-500 ease-out`}
      />
    ),
    path: "/case-log",
  },
  { type: "separator", title: "Statistics" },
  {
    type: "button",
    title: "Statistics",
    icon: (
      <FaChartPie
        className={`w-6 h-6 group-hover:text-primary    transition-all duration-500 ease-out`}
      />
    ),
    path: "/statistics",
  },
  { type: "separator", title: "System" },

  {
    type: "group",
    title: "Configuration",
    icon: (
      <MdSettings
        className={`w-6 h-6 group-hover:text-primary    transition-all duration-500 ease-out`}
      />
    ),
    children: [
      {
        type: "button",
        title: "Incidents Types",
        icon: (
          <MdWorkspacesOutline
            className={`w-6 h-6 group-hover:text-primary    transition-all duration-500 ease-out`}
          />
        ),
        path: "/configuration/incidents-types",
      },
      {
        type: "button",
        title: "Categories",
        icon: (
          <MdOutlineCategory
            className={`w-6 h-6 group-hover:text-primary    transition-all duration-500 ease-out`}
          />
        ),
        path: "/configuration/categories",
      },
      {
        type: "button",
        title: "Locations",
        icon: (
          <MdLocationOn
            className={`w-6 h-6  group-hover:text-primary   transition-all duration-500 ease-out`}
          />
        ),
        path: "/configuration/locations",
      },
      {
        type: "button",
        title: "Disciplinary Actions",
        icon: (
          <FaHammer
            className={`w-6 h-6 group-hover:text-primary shrink-0  transition-all duration-500 ease-out`}
          />
        ),
        path: "/configuration/disciplinary-actions",
      },
      {
        type: "button",
        title: "Finanicial",
        icon: (
          <FaFileInvoiceDollar
            className={`w-6 h-6 group-hover:text-primary    transition-all duration-500 ease-out`}
          />
        ),
        path: "/configuration/financial-loss-recovery",
      },
      {
        type: "button",
        title: "Victims & Subjects",
        icon: (
          <GiSupersonicArrow
            className={`w-6 h-6 group-hover:text-primary shrink-0   transition-all duration-500 ease-out`}
          />
        ),
        path: "/configuration/victims-subjects",
      },
    ],
  },

  // {
  //   type: "button",
  //   title: "Incidents Types",
  //   icon: (
  //     <MdWorkspacesOutline
  //       className={`w-6 h-6 group-hover:text-primary    transition-all duration-500 ease-out`}
  //     />
  //   ),
  //   path: "/configuration/incidents-types",
  // },
  // {
  //   type: "button",
  //   title: "Categories",
  //   icon: (
  //     <MdOutlineCategory
  //       className={`w-6 h-6 group-hover:text-primary    transition-all duration-500 ease-out`}
  //     />
  //   ),
  //   path: "/configuration/categories",
  // },
  // {
  //   type: "button",
  //   title: "Locations",
  //   icon: (
  //     <MdLocationOn
  //       className={`w-6 h-6  group-hover:text-primary   transition-all duration-500 ease-out`}
  //     />
  //   ),
  //   path: "/configuration/locations",
  // },
  // {
  //   type: "button",
  //   title: "Disciplinary Actions",
  //   icon: (
  //     <FaHammer
  //       className={`w-6 h-6 group-hover:text-primary   transition-all duration-500 ease-out`}
  //     />
  //   ),
  //   path: "/configuration/disciplinary-actions",
  // },
  // {
  //   type: "button",
  //   title: "Finanicial",
  //   icon: (
  //     <FaFileInvoiceDollar
  //       className={`w-6 h-6 group-hover:text-primary    transition-all duration-500 ease-out`}
  //     />
  //   ),
  //   path: "/configuration/finanicial-loss-recovery",
  // },
  // {
  //   type: "button",
  //   title: "Victims & Subjects",
  //   icon: (
  //     <GiSupersonicArrow
  //       className={`w-6 h-6 group-hover:text-primary    transition-all duration-500 ease-out`}
  //     />
  //   ),
  //   path: "/configuration/victims-subjects",
  // },
];
